/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { MCUnknown } from './media.unknown.js';

export let MCContainer = function() {
	//var media_class = 6;
	return Object.assign( {}, MCUnknown, {
	} );
}(); // namespace MCContainer
